import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppLayout from './components/base_layout/AppLayout'
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<AppLayout />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js